import { takeLatest, put, call } from 'redux-saga/effects';
import { Map } from 'immutable';

import * as api from 'src/service/api/dcsPublications';
import * as dcsActions from './action';
import toast from 'src/utils/toast';
import { getTranslation } from 'src/i18n/translations';

export function * dcsPublicationRoot () {
  yield takeLatest(dcsActions.FETCH_DCS_PUBLICATION, fetchDcsPublication);
  yield takeLatest(dcsActions.FETCH_DCS_DATA_POINTS, fetchDcsDataPoints);
  yield takeLatest(dcsActions.FETCH_DCS_MAP, fetchDcsMap);
  yield takeLatest(dcsActions.CREATE_DCS_PUBLICATION, createDcsPublication);
  yield takeLatest(dcsActions.UPDATE_DCS_PUBLICATION, updateDcsPublication);
  yield takeLatest(dcsActions.ADD_DCS_POINTS, addDcsPoints);
  yield takeLatest(dcsActions.REMOVE_DCS_POINT, removeDcsPoint);
  yield takeLatest(dcsActions.REASSIGN_DCS_ADDRESSES, reassignDcsAddresses);
  yield takeLatest(dcsActions.RESET_DCS_POINTS, resetDcsPoints);
}

function * fetchDcsPublication (action) {
  try {
    const res = yield call(api.getDcsPublication, action);
    // 204 means the facility has not configured one yet, which is a normal state
    yield put(dcsActions.fetchDcsPublicationSuccess(res?.get ? res : null));
  } catch (err: any) {
    yield put(dcsActions.fetchDcsPublicationFailed(Map(err)));
    toast.error(getTranslation('toast.errorRetrievingDcsPublication'), err?.response?.status);
  }
}

function * fetchDcsDataPoints (action) {
  try {
    const res = yield call(api.getDcsDataPoints, action);
    yield put(dcsActions.fetchDcsDataPointsSuccess(res || Map()));
  } catch (err: any) {
    yield put(dcsActions.fetchDcsDataPointsFailed(Map(err)));
  }
}

function * fetchDcsMap (action) {
  try {
    const res = yield call(api.getDcsMap, action);
    yield put(dcsActions.fetchDcsMapSuccess(res?.get ? res : null));
  } catch (err: any) {
    yield put(dcsActions.fetchDcsMapFailed(Map(err)));
  }
}

function * createDcsPublication (action) {
  try {
    yield call(api.createDcsPublication, action);
    yield put(dcsActions.fetchDcsPublication());
  } catch (err: any) {
    toast.error(getTranslation('toast.errorSavingDcsPublication'), err?.response?.status);
  }
}

function * updateDcsPublication (action) {
  try {
    yield call(api.updateDcsPublication, action);
    yield put(dcsActions.fetchDcsPublication());
  } catch (err: any) {
    toast.error(getTranslation('toast.errorSavingDcsPublication'), err?.response?.status);
  }
}

function * addDcsPoints (action) {
  try {
    yield call(api.addDcsPoints, action);
    // the generated map moves whenever points are added, so pull both back
    yield put(dcsActions.fetchDcsPublication());
    yield put(dcsActions.fetchDcsMap());
  } catch (err: any) {
    toast.error(err?.response?.data?.message || getTranslation('toast.errorSavingDcsPublication'), err?.response?.status);
  }
}

function * removeDcsPoint (action) {
  try {
    yield call(api.removeDcsPoint, action);
    yield put(dcsActions.fetchDcsPublication());
    yield put(dcsActions.fetchDcsMap());
  } catch (err: any) {
    toast.error(getTranslation('toast.errorDeletingDcsPoint'), err?.response?.status);
  }
}

function * reassignDcsAddresses (action) {
  try {
    yield call(api.reassignDcsAddresses, action);
    yield put(dcsActions.fetchDcsPublication());
    yield put(dcsActions.fetchDcsMap());
  } catch (err: any) {
    // the API rejects the whole set on any clash, and its message names the conflict
    toast.error(err?.response?.data?.message || getTranslation('toast.errorSavingDcsPublication'), err?.response?.status);
  }
}

function * resetDcsPoints (action) {
  try {
    yield call(api.resetDcsPoints, action);
    yield put(dcsActions.fetchDcsPublication());
    yield put(dcsActions.fetchDcsMap());
  } catch (err: any) {
    toast.error(err?.response?.data?.message || getTranslation('toast.errorSavingDcsPublication'), err?.response?.status);
  }
}
